import { Player } from "../Model/Player";
export class PlayersFactory {
    constructor(eventsChannelFactory) {
        this.eventsChannelFactory = eventsChannelFactory;
    }
    createPlayer(id, identityOverride, name, pictureId, roomId) {
        return new Player(this.eventsChannelFactory, id, identityOverride, name, pictureId, roomId);
    }
    createPlayerFromDto({ id, identityOverride, name, pictureId, roomId }) {
        return this.createPlayer(id, identityOverride, name, pictureId, roomId);
    }
}
